import type {
  McpAuthorizationDecision,
  McpAuthorizationDecisionResult,
  McpAuthorizationRequest,
} from '@easyhelp/shared';
import { useMutation, useQuery } from '@tanstack/react-query';
import { ApiError, apiRequest } from './client';

/** Chiave della richiesta di collegamento di un client MCP. */
export const mcpAuthorizationQueryKey = (id: string) => ['mcp', 'authorization', id] as const;

/**
 * `GET /mcp/oauth/authorizations/:id`: la richiesta in attesa del consenso (#151). Non si ripete
 * e non si aggiorna da sola: è una schermata che si decide una volta.
 */
export function useMcpAuthorizationRequest(id: string) {
  return useQuery<McpAuthorizationRequest, ApiError>({
    queryKey: mcpAuthorizationQueryKey(id),
    queryFn: () => apiRequest<McpAuthorizationRequest>(`/mcp/oauth/authorizations/${encodeURIComponent(id)}`),
    enabled: id !== '',
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}

/** `POST /mcp/oauth/authorizations/:id/decision`: consenso o rifiuto; restituisce dove mandare il browser. */
export function useDecideMcpAuthorization(id: string) {
  return useMutation<McpAuthorizationDecisionResult, ApiError, McpAuthorizationDecision>({
    mutationFn: (decision) =>
      apiRequest<McpAuthorizationDecisionResult>(`/mcp/oauth/authorizations/${encodeURIComponent(id)}/decision`, {
        method: 'POST',
        body: JSON.stringify({ decision }),
      }),
  });
}

/**
 * Manda il browser fuori dalla console, al client MCP (claude.ai, l'app di Cursor, il loopback di
 * Claude Code). Una funzione a parte perché i test la sostituiscono: jsdom non naviga.
 */
export const browserNavigation = {
  assign(url: string): void {
    window.location.assign(url);
  },
};
